export interface ReturnPageRulesCountryItem {
    countryId: number;
    countryName?: string;
    countryCode?: string;
}

let cachedCountryList: ReturnPageRulesCountryItem[] | null = null;

export const getReturnPageRulesCountryListCache = (): ReturnPageRulesCountryItem[] | null => cachedCountryList;

export const setReturnPageRulesCountryListCache = (list: ReturnPageRulesCountryItem[]): void => {
    if (list?.length) {
        cachedCountryList = list;
    }
};

export const extractCountryListFromPageRulesPayload = (payload: any): ReturnPageRulesCountryItem[] => {
    if (payload?.countryList?.length > 0) {
        return payload.countryList;
    }

    return (payload?.countries || []).map((c: any) => ({
        countryId: c.countryId,
        countryName: c.countryName,
        countryCode: c.countryCode,
    }));
};
